interface Props {
    left: string;
    right: string | number;
    className?: string;
    background?: string;
    rightColor?: string;
}

const InfoSpan = ({ left, right, className, background, rightColor }: Props) => {
    return (
        <div
            style={background ? { backgroundColor: background } : {}}
            className={`px-3 py-2 flex rounded-lg bg-gray_four h-fit ${right ? 'gap-1' : ''} ${className}`}
        >
            <p className={'text-text_gray'}>{left}</p>
            <p className={'text-yellow'} style={rightColor ? { color: rightColor } : {}}>
                {right}
            </p>
        </div>
    );
};

export default InfoSpan;
